import React, {Fragment, useEffect, useRef, useState} from 'react';
import moment from 'moment';

const getHeaderCSRF = () => {
  return {
    "Content-Type": "application/json",
    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
    ?.content,
  }
}

const FakeRating = ({ value }) => {
  // Calculate the number of full stars
  const fullStars = Math.floor(value);
  // Check if there is a half star
  const hasHalfStar = value % 1 >= 0.5;

  // Generate an array of star icons
  const stars = Array.from({ length: 5 }, (_, index) => {
    // Determine the star's class name based on its state (full, half, or empty)
    let className = 'star';
    if (index < fullStars) {
      className += ' full';
    } else if (index === fullStars && hasHalfStar) {
      className += ' half';
    } else {
      className += ' empty';
    }

    return (
      <span key={index} className={className}>
      </span>
    );
  });

  return <div className="utf_star_rating_section" data-nojquery="true" title={value}>{stars}</div>;
}
const getLanguageName = (languageCode) => {
  const languageDisplayNames = new Intl.DisplayNames([navigator.language], { type: 'language' });
  return languageDisplayNames.of(languageCode);
};
const getTranslate = async (text) => {
  const resp = await fetch(`/translate`, {
    method: 'POST',
    headers: getHeaderCSRF(),
    body: JSON.stringify({
      text,
      to: window.navigator.language
    })
  });
  return await resp.json();
}

const Review = (props) => {
  const { listing, review } = props;
  const [isHelpful, setIsHelpful] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [translation, setTranslation] = useState(null);
  const [isTranslated, setIsTranslated] = useState(false);

  const sendHelpful = async (type) => {
    setIsLoading(true)
    fetch(`/listing/${listing.slug}/reviews/${review.id}`, {
      method: 'PUT',
      headers: getHeaderCSRF(),
      body: JSON.stringify({review: {type}})

    }).then((resp) => {
      return resp;
    }).then((resp) => {
      setIsHelpful(type);
      setIsLoading(false);
    }).catch((error) => {
      console.log('error', error);
      setIsHelpful(!isHelpful)
      setIsLoading(false);
    })
  }
  const handleToggleHelpful = (e, type = 'helpful') => {
    e.preventDefault();
    if(isHelpful) return null;
    sendHelpful(type);
  }
  const imgWrapperRef = useRef();
  useEffect(() => {
    if(imgWrapperRef.current && window.jQuery) {
      console.log('trigger')
      window.jQuery(imgWrapperRef.current).magnificPopup({
        type: 'image',
        delegate: 'a.utf_gallery',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: false,
        preloader: true,
        removalDelay: 0,
        mainClass: 'mfp-fade',
        gallery: {
            enabled: true,
            tCounter: ''
        }
    });
    }
  }, []);
  const handleTranslate = (e) => {
    e.preventDefault();
    if(isLoading) return false;
    setIsLoading(true);
    getTranslate(review.message).then((resp) => {
      console.log('getTranslate', resp);
      setTranslation(resp);
      setIsTranslated(true);
      setIsLoading(false);
    }).catch((error) => {
      console.log('error', error);
      setIsLoading(false);
    })    
  }
  const handleShowOriginal = (e) => {
    e.preventDefault();
    setIsTranslated(false);
  }
  const decoratedMessage = translation && isTranslated ? translation.text : review.message;
  const reviewMsg = (decoratedMessage || '').replace(/\n/g,'<br/>');
  const helpfulCount = isHelpful === 'helpful' ?  (+review.helpful + 1) : +review.helpful;
  const unHelpfulCount = isHelpful === 'unhelpful' ?  (+review.unhelpful + 1) : +review.unhelpful
  return (
    <Fragment>
     <li>
        <div className="avatar">
          <img src="/images/avatar.png" alt="avatar"/>
        </div>
        <div className="utf_comment_content">
          <div className="utf_arrow_comment"></div>
          <FakeRating value={review.rating}/>
         
          <div className="utf_by_comment">{review.display_name}<span className="date">
            <i className="fa fa-clock-o"></i> {moment(review.created_at).format('MMMM Do YYYY')}</span> 
          </div>
          <div className='rate-reviews'>
            <a href="#" disabled={isLoading || isHelpful} 
              onClick={e => handleToggleHelpful(e, 'helpful')} 
              title="Helpful"
              className={`rate-review ${(isLoading || isHelpful) ? 'disabled' : ''}`}>
              <i className="fa fa-thumbs-up"></i>
              {
                helpfulCount > 0 && <sup>{helpfulCount}</sup>
              }              
            </a>
            <a href="#" 
              disabled={isLoading || isHelpful} 
              title="Unhelpful"
              onClick={e => handleToggleHelpful(e, 'unhelpful')} 
              className={`rate-review ${(isLoading || isHelpful) ? 'disabled' : ''}`}>
                <i className="fa fa-thumbs-down"></i>
                {
                  unHelpfulCount > 0 && <sup>{unHelpfulCount}</sup>
                }
            </a>

          </div>
          <div dangerouslySetInnerHTML={{__html: reviewMsg}}></div>
          {
            review.images && review.images.length > 0  && <div className="review-images utf_gallery_container" ref={imgWrapperRef}>
              {
                review.images.map((image,idx) => (
                  <a key={`${idx}-${image.url}`} href={`${image.url}`} className="utf_gallery"><img src={`${image.url}`} alt=""/></a>           
                ))
              }
          </div>
          }
          {
            !isTranslated && review.message && <a href="#" className='btn-translate' onClick={handleTranslate}>
              See translation
            </a>
          }
          {
            isTranslated && review.message && <a href="#" className='btn-translate' onClick={handleShowOriginal}>
              <small>Translated by Google ・ <strong>See original ({getLanguageName(translation.from)})</strong></small>
            </a>
          }
        </div>
      </li>
      </Fragment>
  )
}
export default Review;